(() => {
  if (window.__omSizeConfirmationV4Initialized) {
    return;
  }

  window.__omSizeConfirmationV4Initialized = true;

  const SESSION_KEY = 'om-size-guide-confirmed-v4';

  const MODAL_SELECTOR =
    '[data-om-size-confirmation]';

  const PRODUCT_INFO_SELECTOR =
    '.product__info-container';

  const SIZE_GUIDE_SELECTOR =
    '[data-om-size-open]';

  const ADD_TO_CART_SELECTOR =
    'button[name="add"], .product-form__submit';

  const BUY_NOW_SELECTOR =
    '.shopify-payment-button__button, ' +
    '.shopify-payment-button button';

  const PURCHASE_SELECTOR =
    ADD_TO_CART_SELECTOR + ', ' + BUY_NOW_SELECTOR;

  let pendingAction = null;
  let pendingScope = null;
  let bypassNextPurchase = false;
  let memoryConfirmed = false;

  function getModal() {
    return document.querySelector(MODAL_SELECTOR);
  }

  /*
   * This confirmation belongs only to a product purchase area that also
   * has the confirmation markup. Collection-card forms have their own size
   * validation and must never be cancelled by this product-page layer.
   *
   * Fail open if the optional popup is missing: blocking a valid Shopify
   * cart submission is worse than allowing the purchase without this extra
   * reminder.
   */
  function getConfirmationScope(button) {
    if (!button || !getModal()) {
      return null;
    }

    return button.closest(PRODUCT_INFO_SELECTOR);
  }

  function isConfirmed() {
    if (memoryConfirmed) {
      return true;
    }

    try {
      return (
        sessionStorage.getItem(SESSION_KEY) === 'true'
      );
    } catch (error) {
      return memoryConfirmed;
    }
  }

  function markConfirmed() {
    memoryConfirmed = true;

    try {
      sessionStorage.setItem(SESSION_KEY, 'true');
    } catch (error) {
      /* Continue with the in-memory value. */
    }
  }

  function clearPendingAction() {
    pendingAction = null;
    pendingScope = null;
  }

  function isUnavailable(button) {
    if (!button) {
      return true;
    }

    const paymentWrapper = button.closest(
      '.shopify-payment-button'
    );

    return (
      button.disabled === true ||
      button.getAttribute('aria-disabled') === 'true' ||
      (
        paymentWrapper &&
        paymentWrapper.getAttribute(
          'data-om-buy-now-unavailable'
        ) === 'true'
      )
    );
  }

  function getActionType(button) {
    if (
      button.matches(BUY_NOW_SELECTOR) ||
      button.closest('.shopify-payment-button')
    ) {
      return 'buy-now';
    }

    return 'add-to-cart';
  }

  function findLivePurchaseButton() {
    const scope =
      pendingScope &&
      document.contains(pendingScope)
        ? pendingScope
        : document;

    if (pendingAction === 'buy-now') {
      return scope.querySelector(
        '.shopify-payment-button__button:not([disabled]), ' +
        '.shopify-payment-button button:not([disabled])'
      );
    }

    return scope.querySelector(
      'button[name="add"]:not([disabled]), ' +
      '.product-form__submit:not([disabled])'
    );
  }

  function openModal() {
    const modal = getModal();

    if (!modal) {
      console.error(
        'OM Size Confirmation: Popup markup was not found.'
      );

      return;
    }

    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    document.body.classList.add(
      'om-size-confirmation-open'
    );

    const panel = modal.querySelector(
      '.om-size-confirmation__panel'
    );

    window.setTimeout(() => {
      if (panel) {
        panel.focus();
      }
    }, 50);
  }

  function closeModal(clearPending = true) {
    const modal = getModal();

    if (!modal) {
      return;
    }

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    document.body.classList.remove(
      'om-size-confirmation-open'
    );

    if (clearPending) {
      clearPendingAction();
    }
  }

  function continueOriginalPurchase() {
    const targetButton = findLivePurchaseButton();

    if (!targetButton || isUnavailable(targetButton)) {
      console.error(
        'OM Size Confirmation: Original purchase button is unavailable.'
      );

      clearPendingAction();
      return;
    }

    bypassNextPurchase = true;
    clearPendingAction();

    targetButton.click();
  }

  document.addEventListener(
    'click',
    (event) => {
      const closeButton = event.target.closest(
        '[data-om-size-check-close]'
      );

      if (closeButton) {
        event.preventDefault();
        closeModal(true);
        return;
      }

      const viewGuideButton = event.target.closest(
        '[data-om-size-check-view-guide]'
      );

      if (viewGuideButton) {
        event.preventDefault();
        event.stopPropagation();

        const existingGuideButton =
          document.querySelector(SIZE_GUIDE_SELECTOR);

        if (!existingGuideButton) {
          console.error(
            'OM Size Confirmation: Size guide button was not found.'
          );

          return;
        }

        markConfirmed();
        closeModal(true);

        window.setTimeout(() => {
          existingGuideButton.click();
        }, 100);

        return;
      }

      const continueButton = event.target.closest(
        '[data-om-size-check-continue]'
      );

      if (continueButton) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        markConfirmed();
        closeModal(false);

        window.setTimeout(() => {
          continueOriginalPurchase();
        }, 100);

        return;
      }

      const existingGuideButton = event.target.closest(
        SIZE_GUIDE_SELECTOR
      );

      if (existingGuideButton) {
        markConfirmed();
        return;
      }

      const purchaseButton = event.target.closest(
        PURCHASE_SELECTOR
      );

      if (!purchaseButton) {
        return;
      }

      if (bypassNextPurchase) {
        bypassNextPurchase = false;
        return;
      }

      const confirmationScope =
        getConfirmationScope(purchaseButton);

      if (!confirmationScope) {
        return;
      }

      if (
        isConfirmed() ||
        isUnavailable(purchaseButton)
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      pendingAction =
        getActionType(purchaseButton);

      pendingScope = confirmationScope;

      openModal();
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const submitter = event.submitter;

      if (
        !submitter ||
        !submitter.matches(PURCHASE_SELECTOR)
      ) {
        return;
      }

      const confirmationScope =
        getConfirmationScope(submitter);

      if (!confirmationScope) {
        return;
      }

      if (
        isConfirmed() ||
        isUnavailable(submitter)
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      pendingAction = getActionType(submitter);

      pendingScope = confirmationScope;

      openModal();
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Escape') {
        return;
      }

      const modal = getModal();

      if (
        modal &&
        modal.classList.contains('is-open')
      ) {
        closeModal(true);
      }
    }
  );
})();
